import { lowerFirst } from '../string';
import { getPropertyTypeByObjectType } from './getPropertyTypeByObjectType';

export interface ICategoryInfo {
  /** Тип сделки. Значения: 'rent' | 'sale' */
  dealType: string;
  /** Тип объекта */
  objectType: string;
  /** Тип недвижимости. Значения: 'residential' | 'commercial' */
  propertyType: string;
  /** Срок аренды. Значения: 'short' | 'long' */
  rentDuration?: string;
}

export const getCategoryInfo = (category: string | undefined): ICategoryInfo => {
  if (!category) {
    return {} as ICategoryInfo;
  }

  // dailyHouseRent -> ["dailyHouseRent", "daily", "House", "Rent"]
  // freeAppointmentObjectSale -> ["freeAppointmentObjectSale", undefined, "freeAppointmentObject", "Sale"]
  const categoryMatch = category.match(/(daily)?(.*)(Sale|Rent)$/);

  if (!categoryMatch) {
    return {} as ICategoryInfo;
  }

  const categoryInfo: ICategoryInfo = {
    dealType: lowerFirst(categoryMatch[3]),
    objectType: lowerFirst(categoryMatch[2]),
  } as ICategoryInfo;

  if (categoryInfo.dealType === 'rent') {
    categoryInfo.rentDuration = categoryMatch[1] ? 'short' : 'long';
  }

  if (categoryInfo.objectType !== 'coworking') {
    categoryInfo.propertyType = getPropertyTypeByObjectType(categoryInfo.objectType);
  }

  return categoryInfo;
};
